module.exports = function () {
  "use strict";

  var e = {
    881: function _(e, t, n) {
      function r(e) {
        var t,
            n,
            r,
            o = null !== (t = e.minDelayUntilFirstValue) && void 0 !== t ? t : 0,
            u = null !== (n = e.teardownTime) && void 0 !== n ? n : 0,
            a = e.valueIncreaseRatePerSecond,
            i = e.averageTimeBetweenValues,
            l = e.maxValue,
            c = e.valueIncreaseDelta,
            f = Date.now(),
            v = 0,
            m = 0;

        function d(e) {
          return e.value === l;
        }

        function s(e, t, n) {
          var r = function (e, t) {
            return 1 - Math.exp(-(e - t) / (3.5 * i));
          }(t, n);

          return r * e + (1 - r) * m;
        }

        function p(e) {
          return t = null != e ? e : Date.now(), (n = void 0 !== r ? function (e, t) {
            if (d(e)) {
              var n = Math.max(1e3, u),
                  r = (t - e.time) / n,
                  o = (i = Math.min(1, r)) * i,
                  a = e.value - m;
              return m + a * o;
            }

            var i;
            return s(e.value, t, f);
          }(r, t) : function (e) {
            var t = Math.min(c, .33 * l),
                n = (e - f) / (o + t / a * 1e3);
            return Math.min(1, n) * t;
          }(t)) > v && (v = n), v;
          var t, n;
        }

        return {
          setValue: function setValue(e, t) {
            if (void 0 !== r) {
              if (d(r)) return;
              m = s(r.value, r.time, f), f = r.time;
            }

            r = {
              time: null != t ? t : Date.now(),
              value: Math.min(e, l)
            };
          },
          smoothedValue: p,
          smoothedFactor: function smoothedFactor(e) {
            return p(e) / l;
          }
        };
      }

      n.r(t), n.d(t, {
        ProgressSmoother: function ProgressSmoother() {
          return r;
        }
      });
    }
  },
      t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      exports: {}
    };
    return e[r](o, o.exports, n), o.exports;
  }

  return n.d = function (e, t) {
    for (var r in t) {
      n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n(881);
}();